define(function (require) {
    const defaultNameSpace = 'PROCESSMANAGER';   
	return {
		saveSessionData: function(sessionData, sessionName, namespace = defaultNameSpace) {
            App.sessionStorage.set(namespace, sessionName, sessionData);
        },
		getSessionData: function (sessionName, namespace = defaultNameSpace) {
            return App.sessionStorage.get(namespace, sessionName);
        },
		clearSessionData: function(sessionName, namespace = defaultNameSpace) {
            App.sessionStorage.remove(namespace, sessionName);
        }
	};
});
